import { STATUS_OBJ, STATUS_BROKER } from 'utils/statusEnum';

export const STATUS_LIST = {
  gestao: 'status',
  corretora: 'statusBroker',
};

export const statusList = [
  {
    label: STATUS_BROKER.indemnified,
    value: 'indemnifiedBroker',
    searchValue: 'indemnified',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.closed,
    value: 'closedBroker',
    searchValue: 'closed',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendent,
    value: 'pendentBroker',
    searchValue: 'pendent',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingInsured,
    value: 'pendingInsured',
    searchValue: 'pendingInsured',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingInsurance,
    value: 'pendingInsurance',
    searchValue: 'pendingInsurance',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingRegulatory,
    value: 'pendingRegulatory',
    searchValue: 'pendingRegulatory',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingInsuredAgreement,
    value: 'pendingInsuredAgreement',
    searchValue: 'pendingInsuredAgreement',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingPayment,
    value: 'pendingPayment',
    searchValue: 'pendingPayment',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.pendingAgreement,
    value: 'pendingAgreement',
    searchValue: 'pendingAgreement',
    type: STATUS_LIST.corretora,
  },
  {
    label: STATUS_BROKER.indemnifiedPP,
    value: 'indemnifiedPP',
    searchValue: 'indemnifiedPP',
    type: STATUS_LIST.corretora,
  },
];

export const movementSearchList = [
  {
    label: STATUS_OBJ.Analysis,
    value: 'analysis',
    searchValue: 'analysis',
    type: STATUS_LIST.gestao,
  },
  {
    label: STATUS_OBJ.Pendent,
    value: 'pendent',
    searchValue: '',
    type: STATUS_LIST.gestao,
  },
  {
    label: STATUS_OBJ.Closed,
    value: 'closed',
    searchValue: 'pendent',
    type: STATUS_LIST.gestao,
  },
  {
    label: STATUS_OBJ.Compensated,
    value: 'compensated',
    searchValue: 'compensated',
    type: STATUS_LIST.gestao,
  },
  {
    label: STATUS_OBJ.CompensatedPP,
    value: 'compensatedPP',
    searchValue: 'compensatedPP',
    type: STATUS_LIST.gestao,
  },
];

export const movementList = [
  { label: 'Novos no período', value: '' },
  { label: 'Encerrado', value: 'closed' },
  { label: 'Indenizado', value: 'compensated' },
];

export const managementHomeStruture = {
  tables: ['tableA', 'tableB', 'tableC'],
  types: ['status', 'movement'],
};
